module.exports = __webpack_public_path__ + "img/section4.0c896d61.jpg";